import { AppDomainConfig } from "../../envConfig";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["io"],
  font: "16px arial",
  iconCategories,
  id: "trenord",
  name: "Trenord",
  slug: "trenordit",
  ...colors,
};
export default config;
